export class CedenteCadastro {
    constructor(
        public cnpj: string,
        public nomeFantasia: string,
        public razaoSocial: string,
        public inscricaoEstadual: string,
        public inscricaoMunicipal: string,
        public email: string,
        public emailConfirmacao: string,
        public senha: string,
        public senhaConfirmacao: string,
        public appKey: string,        
        public telefoneNumero: string
    ) {}
}
